import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../../../components/Button";

interface NoteModalButtonsProps {
  loading: boolean;
  onCancel: () => void;
  onSave: (e?: React.FormEvent) => void;
}

const NoteModalButtons: React.FC<NoteModalButtonsProps> = ({
  loading,
  onCancel,
  onSave
}) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex gap-3">
      <Button
        className="btn btn-primary"
        text={t("reconciliation.payout.list.pageTexts.modals.note.saveBtn")}
        loading={loading}
        onClick={onSave}
      />
      <Button
        className="btn btn-outline-secondary"
        text={t("reconciliation.payout.list.pageTexts.modals.note.cancelBtn")}
        onClick={onCancel}
      />
    </div>
  );
}

export default NoteModalButtons;
